import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function ProtectedRoute({ Component, LoginComponent }) {
  // Pobranie accessToken i userRole z Redux
  const accessToken = useSelector((state) => state.tokens.accessToken);
  const userRole = useSelector((state) => state.tokens.userRole);

  // Lokalny stan do wymuszenia renderowania
  const [isAuthorized, setIsAuthorized] = useState(
    accessToken !== '' && (userRole === '[SYSTEM_ADMIN]' || userRole === '[EVENT_ADMIN]' )
  );

  useEffect(() => {
    // Aktualizacja stanu, gdy accessToken lub userRole się zmienia
    setIsAuthorized(accessToken !== '' && ( userRole === '[SYSTEM_ADMIN]' || userRole === '[EVENT_ADMIN]' ));
  }, [accessToken, userRole]);

  return isAuthorized ? <Component /> : <LoginComponent />;
}

export default ProtectedRoute;